"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aggregatePasData = void 0;
exports.filterAndSortPriceAssociations = filterAndSortPriceAssociations;
exports.getFulfillerRoutedStage = getFulfillerRoutedStage;
exports.getPriceAdjustmentLinkHref = getPriceAdjustmentLinkHref;
exports.getPriceCreatePermissionUri = getPriceCreatePermissionUri;
exports.getPriceExplorerLink = getPriceExplorerLink;
exports.getPriceExplorerUserSelections = getPriceExplorerUserSelections;
exports.getPriceModelV2LinkHref = getPriceModelV2LinkHref;
exports.getTotalAmountFromPases = getTotalAmountFromPases;
exports.hasPriceAdjustments = hasPriceAdjustments;
exports.isCustomPrice = isCustomPrice;
exports.isValidPrice = isValidPrice;
exports.priceLinksContainPriceModelV1 = priceLinksContainPriceModelV1;
exports.priceLinksContainPriceModelV2 = priceLinksContainPriceModelV2;
var _pricingResource = require("../constants/pricingResource");
var _sorting = require("./sorting");
var _KeyValueClient = require("../apis/KeyValueClient");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = new RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) { i++; } r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var sortByCreatedAtFn = (0, _sorting.genericSortByFn)('createdAt');
function getFulfillerRoutedStage(priceInfo) {
  return ((priceInfo || {}).stages || []).find(function (s) {
    return s.type === 'fulfillerRouted';
  });
}
function isValidPrice(price) {
  return price && price.currency && price.currency !== 'XXX';
}
function isCustomPrice(pas) {
  var _pas$_embedded, _pas$_embedded$price;
  return (pas === null || pas === void 0 ? void 0 : (_pas$_embedded = pas._embedded) === null || _pas$_embedded === void 0 ? void 0 : (_pas$_embedded$price = _pas$_embedded.price) === null || _pas$_embedded$price === void 0 ? void 0 : _pas$_embedded$price.sourceType) === 'customQuote';
}
function hasPriceAdjustments(pases) {
  return pases.some(function (pas) {
    var _pas$_embedded2, _pas$_embedded2$price;
    return ((_pas$_embedded2 = pas._embedded) === null || _pas$_embedded2 === void 0 ? void 0 : (_pas$_embedded2$price = _pas$_embedded2.price) === null || _pas$_embedded2$price === void 0 ? void 0 : _pas$_embedded2$price.sourceType) === 'adjustment';
  });
}
function getTotalAmountFromPases(priceAssociations) {
  var _priceAssociations$0$, _priceAssociations$0$2;
  if (priceAssociations.length === 0) {
    return {};
  }
  var currency = (_priceAssociations$0$ = priceAssociations[0]._embedded) === null || _priceAssociations$0$ === void 0 ? void 0 : (_priceAssociations$0$2 = _priceAssociations$0$.price) === null || _priceAssociations$0$2 === void 0 ? void 0 : _priceAssociations$0$2.currency;
  var priceAssociationsWithPrice = priceAssociations.filter(function (pas) {
    var _pas$_embedded3;
    return (pas === null || pas === void 0 ? void 0 : (_pas$_embedded3 = pas._embedded) === null || _pas$_embedded3 === void 0 ? void 0 : _pas$_embedded3.price) !== undefined;
  });
  if (priceAssociationsWithPrice.length === 0) {
    return;
  }
  var amount = priceAssociationsWithPrice.reduce(function (acc, pas) {
    return acc + pas._embedded.price.amount;
  }, 0);
  return {
    amount: "".concat(amount),
    currency: currency
  };
}

// TODO: Add at least one unit test where we assert that data has been sorted by createdAt
function filterAndSortPriceAssociations(priceAssociations, priceAssociationsType) {
  var filteredPriceAssociations = priceAssociations.filter(function (_ref) {
    var type = _ref.type;
    return type === priceAssociationsType;
  });
  if (filteredPriceAssociations.length === 0) {
    return [];
  }
  filteredPriceAssociations = filteredPriceAssociations.filter(function (pas) {
    var _pas$_embedded4, _pas$_embedded4$price, _pas$_embedded5, _pas$_embedded5$price;
    return ((_pas$_embedded4 = pas._embedded) === null || _pas$_embedded4 === void 0 ? void 0 : (_pas$_embedded4$price = _pas$_embedded4.price) === null || _pas$_embedded4$price === void 0 ? void 0 : _pas$_embedded4$price.sourceType) !== 'claim' && ((_pas$_embedded5 = pas._embedded) === null || _pas$_embedded5 === void 0 ? void 0 : (_pas$_embedded5$price = _pas$_embedded5.priceError) === null || _pas$_embedded5$price === void 0 ? void 0 : _pas$_embedded5$price.sourceType) !== 'claim';
  });
  if (filteredPriceAssociations.some(function (p) {
    var _p$_embedded, _p$_embedded$price;
    return (_p$_embedded = p._embedded) === null || _p$_embedded === void 0 ? void 0 : (_p$_embedded$price = _p$_embedded.price) === null || _p$_embedded$price === void 0 ? void 0 : _p$_embedded$price.statusCode;
  })) {
    return [];
  }
  filteredPriceAssociations.sort(sortByCreatedAtFn);
  return filteredPriceAssociations;
}
var aggregatePasData = function aggregatePasData(inflatedPriceAssociations) {
  if (inflatedPriceAssociations.length === 0) {
    return {};
  }
  var uniqueCurrencies = _toConsumableArray(new Set(inflatedPriceAssociations.filter(function (_ref2) {
    var price = _ref2.price;
    return (price === null || price === void 0 ? void 0 : price.currency) !== undefined;
  }).map(function (_ref3) {
    var price = _ref3.price;
    return price.currency;
  })));
  var hasConsistentCurrencies = uniqueCurrencies.length < 2;
  var baseInflatedPriceAssociation = inflatedPriceAssociations[0];
  var adjustmentPriceAssociations = inflatedPriceAssociations.filter(function (_ref4) {
    var price = _ref4.price;
    return (price === null || price === void 0 ? void 0 : price.sourceType) === 'adjustment';
  });

  // There's little point in summing up amounts which have different currencies
  var totalAmount = hasConsistentCurrencies ? getTotalAmountFromPases(inflatedPriceAssociations) : {};
  return {
    price: baseInflatedPriceAssociation.price,
    source: baseInflatedPriceAssociation.source,
    errors: baseInflatedPriceAssociation.errors,
    priceAssociation: baseInflatedPriceAssociation,
    hasConsistentCurrencies: hasConsistentCurrencies,
    currencies: uniqueCurrencies,
    totalAmount: totalAmount,
    adjustmentPriceAssociations: adjustmentPriceAssociations
  };
};
exports.aggregatePasData = aggregatePasData;
function priceLinksContainPriceModelV1(priceLinks) {
  return (priceLinks === null || priceLinks === void 0 ? void 0 : priceLinks.priceModel) !== undefined;
}
function priceLinksContainPriceModelV2(priceLinks) {
  return (priceLinks === null || priceLinks === void 0 ? void 0 : priceLinks.priceConfiguration) !== undefined && (priceLinks === null || priceLinks === void 0 ? void 0 : priceLinks.priceConfigurationPrice);
}
function getPriceModelV2LinkHref(priceLinks) {
  var priceConfigurationId;
  var priceConfigurationPriceId;
  var priceConfigurationResourceLink = priceLinks.priceConfiguration,
    priceConfigurationPriceResourceLink = priceLinks.priceConfigurationPrice;
  if (!priceConfigurationResourceLink || !priceConfigurationPriceResourceLink) {
    return null;
  }
  var priceConfigurationHref = priceConfigurationResourceLink.href,
    priceConfigurationLinkName = priceConfigurationResourceLink.name;
  var priceConfigurationPriceHref = priceConfigurationPriceResourceLink.href,
    priceConfigurationPriceName = priceConfigurationPriceResourceLink.name;
  if (priceConfigurationLinkName && priceConfigurationPriceName) {
    priceConfigurationId = priceConfigurationLinkName;
    priceConfigurationPriceId = priceConfigurationPriceName;
  } else {
    var _priceConfigurationRe, _priceConfigurationRe2, _priceConfigurationPr, _priceConfigurationPr2;
    // todo: one day we won't need to do this, but we don't always have the `name` attribute in the link objects.

    // format: https://priceconfiguration.ff.cimpress.io/api/v1/priceConfigurations/8832fccb-a4c7-4c33-a1dd-b42f41028ce4
    var priceConfigurationRegexCapture = priceConfigurationHref.match( /*#__PURE__*/_wrapRegExp(/\/priceConfigurations\/([^/]+)/, {
      priceConfigurationId: 1
    }));
    priceConfigurationId = (_priceConfigurationRe = priceConfigurationRegexCapture === null || priceConfigurationRegexCapture === void 0 ? void 0 : (_priceConfigurationRe2 = priceConfigurationRegexCapture.groups) === null || _priceConfigurationRe2 === void 0 ? void 0 : _priceConfigurationRe2.priceConfigurationId) !== null && _priceConfigurationRe !== void 0 ? _priceConfigurationRe : null;

    // format: https://priceconfiguration.ff.cimpress.io/api/v1/prices/2d349969-42d4-4014-ad27-fea99d4cf68f/versions/1
    var priceConfigurationPriceRegexCapture = priceConfigurationPriceHref.match( /*#__PURE__*/_wrapRegExp(/\/prices\/([^/]+)/, {
      priceConfigurationPriceId: 1
    }));
    priceConfigurationPriceId = (_priceConfigurationPr = priceConfigurationPriceRegexCapture === null || priceConfigurationPriceRegexCapture === void 0 ? void 0 : (_priceConfigurationPr2 = priceConfigurationPriceRegexCapture.groups) === null || _priceConfigurationPr2 === void 0 ? void 0 : _priceConfigurationPr2.priceConfigurationPriceId) !== null && _priceConfigurationPr !== void 0 ? _priceConfigurationPr : null;
    if (!priceConfigurationId || !priceConfigurationPriceId) {
      return null;
    }
  }
  return "https://pricing.cimpress.io/edit/".concat(priceConfigurationId, "/prices/").concat(priceConfigurationPriceId);
}
function getPriceAdjustmentLinkHref(priceAdjustments) {
  return priceAdjustments.map(function (p) {
    var _p$price, _p$price$_links, _p$price$_links$sourc;
    return (_p$price = p.price) === null || _p$price === void 0 ? void 0 : (_p$price$_links = _p$price._links) === null || _p$price$_links === void 0 ? void 0 : (_p$price$_links$sourc = _p$price$_links.source) === null || _p$price$_links$sourc === void 0 ? void 0 : _p$price$_links$sourc.href;
  });
}
function getPriceCreatePermissionUri(fulfillerId) {
  return "https://api.cimpress.io/auth/access-management/v1/principals/self/permissions/fulfillers/".concat(fulfillerId, "/").concat(_pricingResource.CREATE_PRICE_PERMISSION);
}
function normalizeInputKey(key) {
  return key.toLowerCase().replace(/ /g, '');
}
function getPriceExplorerUserSelections(inputs) {
  var _inputs$find;
  var quantity = (_inputs$find = inputs.find(function (_ref5) {
    var name = _ref5.name;
    return normalizeInputKey(name) === 'quantity';
  })) === null || _inputs$find === void 0 ? void 0 : _inputs$find.value;
  var initialAttributeSelections = [];
  var inputsGroupedByScope = inputs.reduce(function (acc, item) {
    acc[item.scope] = acc[item.scope] || [];
    acc[item.scope].push(item);
    return acc;
  }, {});
  initialAttributeSelections = Object.entries(inputsGroupedByScope).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      scope = _ref7[0],
      items = _ref7[1];
    return items.map(function (_ref8) {
      var name = _ref8.name,
        value = _ref8.value;
      return {
        classes: [{
          name: scope
        }],
        isDisplayed: true,
        key: name,
        resolvedValue: value
      };
    });
  }).flat(1);
  return {
    initialAttributeSelections: initialAttributeSelections,
    initialPivotingSelections: {
      firstAttribute: {
        key: "Quantity",
        selectedValues: [quantity]
      }
    },
    initialShippingSelections: null,
    grossMarginSelections: {},
    selectedTab: "price"
  };
}
function getPriceExplorerLink(_x, _x2) {
  return _getPriceExplorerLink.apply(this, arguments);
}
function _getPriceExplorerLink() {
  _getPriceExplorerLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accessToken, inputs) {
    var _inputs$find2, _inputs$find3;
    var client,
      baseUrl,
      productId,
      mcpSku,
      mcpSkuOrProductId,
      valueToPost,
      keyValueKey,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _args.length > 2 && _args[2] !== undefined ? _args[2] : new _KeyValueClient.KeyValueClient();
            baseUrl = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'https://priceexplorer.financialflows.cimpress.io/calculator';
            if (!(!Array.isArray(inputs) || inputs.length === 0)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", null);
          case 4:
            productId = (_inputs$find2 = inputs.find(function (_ref9) {
              var scope = _ref9.scope,
                name = _ref9.name;
              return normalizeInputKey(scope) === 'product' && normalizeInputKey(name) === 'productid';
            })) === null || _inputs$find2 === void 0 ? void 0 : _inputs$find2.value;
            mcpSku = (_inputs$find3 = inputs.find(function (_ref10) {
              var scope = _ref10.scope,
                name = _ref10.name;
              return normalizeInputKey(scope) === 'order' && normalizeInputKey(name) === 'mcpsku';
            })) === null || _inputs$find3 === void 0 ? void 0 : _inputs$find3.value;
            if (!(mcpSku === undefined && productId === undefined)) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", null);
          case 8:
            mcpSkuOrProductId = mcpSku !== null && mcpSku !== void 0 ? mcpSku : productId;
            valueToPost = JSON.stringify(getPriceExplorerUserSelections(inputs));
            _context.next = 12;
            return client.postValue(accessToken, valueToPost);
          case 12:
            keyValueKey = _context.sent;
            return _context.abrupt("return", "".concat(baseUrl, "/").concat(mcpSkuOrProductId, "/").concat(keyValueKey));
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPriceExplorerLink.apply(this, arguments);
}